module.exports = __webpack_public_path__ + "img/工业制冷云平台.4b121ecb.png";